import React,{ useRef, useState } from 'react';
import service from './services/service'
import { FileUpload } from 'primereact/fileupload';
import { Dropdown } from 'primereact/dropdown';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
//Bu kompoennt dinamik oluşturulan tablolara farklı dosyalar ile toplu veri eklemek için geliştirilmiştir.
export const ImportFileComponent=(props)=> {
    const toast = useRef(null);

    const [selectedImportType, setSelectedImportType] = useState(null);
    //Import edilebilcek dosya  tiplerini tutar
    const importTypes =
        [
            {
                label: "Excel",
                url: "DynamicFileImport/ImportFile",
                sampleUrl: "DynamicFileImport/DownloadExampleFile",
                acceptType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                type: 0
            },
            {
              
                label: "GeoJson",
                url: "DynamicFileImport/ImportFile",
                sampleUrl: "DynamicFileImport/DownloadExampleFile",
                acceptType: "application/JSON",
                type: 1
            },
            {
                label: "Kml",
                url: "DynamicFileImport/ImportFile",
                sampleUrl: "DynamicFileImport/DownloadExampleFile",
                acceptType: "application/vnd.google-earth.kml+xml",
                type:2
            }

        ];

    const customUploader = async (event) => {

        const file = event.files[0];
        const formData = new FormData();
        formData.append('file', file);
        service.postForm((props.apiUrl + "/" + selectedImportType.url) + "?_tableId=" + props.table.id + "&_fileType=" + selectedImportType.type, formData).then(x => {
            if (!x.success) {
                toast.current.show({ severity: 'error', summary: 'Bilgi', detail: x.message });
                return console.log(x.message);
            }
            if (props.onLoadData) {

                props.onLoadData(x);
            }
            toast.current.show({ severity: 'success', summary: 'Bilgi', detail: x.message });
            
        }).catch((e) => {
            console.log(e);
        });
    };
    //Kullanıcı dosya eklerken hangi kolonlara ne gireceğini görebileceği  örnek bir template oluşturur
    const createExcelFile = async () => {
        try {
            var response = await service.getFileRequest((props.apiUrl + "/" + selectedImportType.sampleUrl) + "?_tableId=" + props.table.id + "&_fileType=" + selectedImportType.type)
            if (!response.ok) {
                throw new Error("HTTP error " + response.status);
            }
            const blob = await response.blob();
            // Dosyayı indirmek için bir link oluşturun ve tıklama işlemini tetikler
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sample.xlsx');
            document.body.appendChild(link);
            link.click();
            //İşlem bitince oluşturulan blob urlsini temizler
            window.URL.revokeObjectURL(url);
        } catch (e) {

        }
    }

    if (1 == 1) {
        return (null);
    }
    return (
      
        <Card title="Dosyadan Veri Yükle">
            <Toast ref={toast}></Toast>
            <div className="col-12 md:col-4">
                <div className="p-inputgroup">
                    {selectedImportType && <Button onClick={createExcelFile} label="Örnek Dosya İndir" />}
                    <span className="p-float-label">
                        <Dropdown value={selectedImportType} onChange={(e) => setSelectedImportType(e.value)} options={importTypes} optionLabel="label"
                            placeholder="Dosya Tipi Seçiniz" className="w-full md:w-14rem" />
                        <label htmlFor="dropdown">Dosya Tipi Seçiniz</label>
                    </span>
                </div>
            </div>

            <br />

            <br />
            <br />
            {selectedImportType && <FileUpload
                accept={selectedImportType.acceptType}
                uploadHandler={customUploader}
                customUpload
                mode="basic" name="file"
                maxFileSize={1000000} />}

        </Card>)

}

export default ImportFileComponent;